// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-dialog {
  min-height: 20rem;
  min-width: 25rem;
}
.settings-dialog .form {
  min-height: 100%;
  min-width: 100%;
  margin-bottom: 1rem;
  background-color: var(--dialog-background-color);
  color: var(--dialog-foreground-color);
}
.settings-dialog .drawer {
  width: 90%;
}
.settings-dialog .related {
  height: 0;
}
.settings-dialog .padding {
  padding-left: 1rem;
}
.settings-dialog .settings-padding {
  margin-right: 1rem;
}
.settings-dialog .min-max {
  width: 5rem;
}
.settings-dialog .time-horizon {
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 1rem;
}
.settings-dialog .time-duration {
  width: 4rem;
  padding-left: 1rem;
}
.settings-dialog .edit-virtual-scroll {
  min-height: 15rem;
  width: 100%;
}
.settings-dialog .search-row {
  display: flex;
  align-items: center;
}
.settings-dialog .search-row .show-all {
  margin-left: auto;
}
.settings-dialog .font-size {
  width: 4rem;
}
.settings-dialog .title {
  width: 20rem;
}
.settings-dialog .precision {
  width: 4rem;
}
.settings-dialog .custom {
  width: 18rem;
}`, "",{"version":3,"sources":["webpack://./src/app/widgets/list-widget/list-widget-settings/list-widget-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,gBAAA;AACJ;AACI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gDAAA;EACA,qCAAA;AACR;AAEI;EACI,UAAA;AAAR;AAGI;EACI,SAAA;AADR;AAII;EACI,kBAAA;AAFR;AAKI;EACI,kBAAA;AAHR;AAMI;EACI,WAAA;AAJR;AAOI;EACI,uBAAA;EAAA,kBAAA;EACA,kBAAA;AALR;AAQI;EACI,WAAA;EACA,kBAAA;AANR;AASI;EACI,iBAAA;EACA,WAAA;AAPR;AAUI;EACI,aAAA;EACA,mBAAA;AARR;AAUQ;EACI,iBAAA;AARZ;AAYI;EACI,WAAA;AAVR;AAaI;EACI,YAAA;AAXR;AAcI;EACI,WAAA;AAZR;AAeI;EACI,YAAA;AAbR","sourcesContent":[".settings-dialog {\n    min-height: 20rem;\n    min-width: 25rem;\n\n    .form {\n        min-height: 100%;\n        min-width: 100%;\n        margin-bottom: 1rem;\n        background-color: var(--dialog-background-color);\n        color: var(--dialog-foreground-color);\n    }\n\n    .drawer {\n        width: 90%;\n    }\n\n    .related {\n        height: 0;\n    }\n\n    .padding {\n        padding-left: 1rem;\n    }\n\n    .settings-padding {\n        margin-right: 1rem;\n    }\n\n    .min-max {\n        width: 5rem;\n    }\n\n    .time-horizon {\n        width: fit-content;\n        padding-left: 1rem;\n    }\n\n    .time-duration {\n        width: 4rem;\n        padding-left: 1rem;\n    }\n\n    .edit-virtual-scroll {\n        min-height: 15rem;\n        width: 100%;\n    }\n\n    .search-row {\n        display: flex;\n        align-items: center;\n\n        .show-all {\n            margin-left: auto;\n        }\n    }\n\n    .font-size {\n        width: 4rem;\n    }\n\n    .title {\n        width: 20rem;\n    }\n    \n    .precision {\n        width: 4rem;\n    }\n\n    .custom {\n        width: 18rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
